export default {
  our_team_title: {
    en: 'Our Team',
    fr: 'Notre équipe',
  },
  team_administration_title: {
    fr: 'Comité exécutif',
    en: 'Executive committee',
  },
  team_administration_description: {
    en: 'Management team of the club',
    fr: 'Équipe administrative du club',
  },
  team_production_title: {
    en: 'Production',
    fr: 'Production',
  },
  team_production_description: {
    en: 'Production team of the club',
    fr: 'Équipe de production du club',
  },
  team_technology_title: {
    en: 'Technology',
    fr: 'Technologie',
  },
  team_technology_description: {
    en: 'Technology team of the club',
    fr: 'Équipe technologique du club',
  },
  team_communication_title: {
    en: 'communication',
    fr: 'Communication',
  },
  team_communication_description: {
    en: 'Communication team of the club',
    fr: 'Équipe de communication du club',
  },
};
